/**
 * Puts one attachment line into the answer at the cursor (design outreach-v2 m1: each chip adds one
 * line). The line stands on its own line. With no known cursor, the line goes at the end.
 * Returns the new text and the cursor after the line.
 */
export function insertAttachmentLine(
  body: string,
  line: string,
  cursor: number | null
): { text: string; cursor: number } {
  const at = cursor === null ? body.length : Math.min(Math.max(cursor, 0), body.length);
  const before = at === body.length ? body.replace(/\s+$/, '') : body.slice(0, at);
  const after = body.slice(at);
  const head = before === '' || before.endsWith('\n') ? before : `${before}\n`;
  const tail = after === '' || after.startsWith('\n') ? after : `\n${after}`;
  const text = `${head}${line}${tail}`;
  return { text, cursor: head.length + line.length };
}
